
import React from 'react';
import { Col, Form, Row, FormControl, Checkbox, Radio, ButtonToolbar, Button } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { DATE_FORMAT, REGEX_DATE, EMPTY_STRING, EMPTY_COUNT, PROPOSAL_ID, DAY_KANA_CUSTOM, PREFIX_HOUR, MIN_DB_DATE_EXACT, MAX_DB_DATE_EXACT } from '../../../utils/constants';
import JapaneseDatePicker from '../../components/JapaneseDatePicker';
import SelectInput from '../../components/SelectInput';

const ProposalForm = (props) => {

    const defaultInput = "proposal-input";
    const formInput = "form-input";
    const formLabel = "form-label";
    const formContent = "form-content";
    const requiredInput = "required-input";
    const DEFAULT_MIN_LENGTH = 0;
    const MAX_ID_LENGTH = 3;
    const MAX_NAME_LENGTH = 40;
    const MAX_REMARKS_LENGTH = 256;
    const SHOW_PRICE_VALUE = 1;
    const NO_PRICE_VALUE = 0;
    const MAX_HOUR = 23;
    const MAX_SINGLE_HOUR = 9;
    let checkboxStyle = { paddingLeft: "4px" };

    const hoursValue = () => {
        let hours = [];

        for (let i = EMPTY_COUNT; i <= MAX_HOUR; i++) {
            let item = (i <= MAX_SINGLE_HOUR ? PREFIX_HOUR : EMPTY_STRING) + i;
            hours[i] = {
                name: "deadlineHour",
                value: item,
                label: item
            }
        }

        return hours;
    }

    const textInput = (inputName, inputType, min, max) => {
        let isDisabled = PROPOSAL_ID === inputName && props.editMode;
        return (
            <FormControl
                type={"text"}
                componentClass={inputType ? inputType : "input"}
                className={"textarea" === inputType ? [formInput, "proposal-textarea"] : formInput}
                name={inputName}
                onChange={isDisabled ? ()=>{} : props.handleInputChange}
                value={props[inputName]}
                minLength={min}
                maxLength={max}
                disabled={isDisabled}
            />
        )
    }

    const datePicker = (inputName) => {
        return (
            <Col sm={5} className={[defaultInput, "proposal-date-form"]}>
                <JapaneseDatePicker
                    outerIcon={true}
                    className="proposal-datepicker"
                    selected={props[inputName].match(REGEX_DATE) && !(MIN_DB_DATE_EXACT >= props[inputName] || MAX_DB_DATE_EXACT <= props[inputName]) ? moment(props[inputName]) : null}
                    name={inputName}
                    onChange={props.handleDateChange.bind(this, inputName, DATE_FORMAT)}
                    dateFormat={DATE_FORMAT}
                    onChangeRaw={props.handleDateChangeRaw}
                />
            </Col>
        )
    }

    const checkBox = (inputName) => {
        return (
            <Checkbox
                name={inputName}
                onChange={props.handleCheckboxChange}
                className="proposal-checkbox"
                checked={props[inputName]}
            />
        )
    }

    const selectForm = (inputName, values) => {
        return (
            <SelectInput
                componentClass={"select"}
                className={[formInput, "proposal-select"]}
                name={inputName}
                onChange={props.handleInputChange}
                value={props[inputName]}
                selectInput={values}
            />
        )
    }

    const RowOne = (
        <Row className="fixed-row-one">
            <Col lg={8} className={defaultInput}>

                <Col lg={6} className={defaultInput}>
                    <Col lg={4} className={[requiredInput, formLabel, "proposal-id-label"]}>グループID</Col>
                    <Col lg={8} className={"form-content proposal-id-input"}>{textInput("proposalId", EMPTY_STRING, DEFAULT_MIN_LENGTH, MAX_ID_LENGTH)}</Col>
                </Col>

                <Col lg={6} className={defaultInput}>
                    <Col lg={4} className={[requiredInput, formLabel]}>グループ名</Col>
                    <Col lg={8} className={formContent}>{textInput("proposalName", EMPTY_STRING, DEFAULT_MIN_LENGTH, MAX_NAME_LENGTH)}</Col>
                </Col>

            </Col>

            <Col lg={4} className={defaultInput}>

                <Col lg={4} className={[requiredInput, formLabel, "proposal-right-label"]}>送料入力要</Col>

                <Col lg={8} className={[formContent, "proposal-right-input"]}>
                    <div className="blank-input-bg">
                        <Checkbox
                            name={"requireShipping"}
                            onChange={props.handleCheckboxChange}
                            className="shipping-checkbox"
                            checked={props.requireShipping}
                        />
                    </div>
                </Col>

            </Col>
        </Row>
    );

    const RowTwo = (
        <Row className="fixed-row-one">
            <Col lg={8} className={defaultInput}>

                <Col lg={2} className={"form-label proposal-wide-input"}>提案期間</Col>

                <Col lg={10} className={["proposal-dates", formContent]}>
                    {datePicker("proposalStartDate")}
                    <Col sm={2} className="proposaldate-separator"><p className="full-width"> 〜 </p></Col>
                    {datePicker("proposalEndDate")}
                </Col>

            </Col>

            <Col lg={4} className={defaultInput}>

                <Col lg={4} className={[requiredInput, formLabel, "proposal-right-label"]}>価格表示</Col>

                <Col lg={8} className={[formContent, "proposal-right-input"]}>
                    <div className="blank-input-bg padding-proposal-radio">
                        <Radio inline={true} name="displayPrice" value={SHOW_PRICE_VALUE} checked={SHOW_PRICE_VALUE === parseInt(props["displayPrice"])} onChange={props.handleInputChange}>
                            <span className="proposal-radio">する</span>
                        </Radio>
                        <Radio inline={true} name="displayPrice" value={NO_PRICE_VALUE} checked={NO_PRICE_VALUE === parseInt(props["displayPrice"])} onChange={props.handleInputChange}>
                            <span className="proposal-radio">しない</span>
                        </Radio>
                    </div>
                </Col>
            </Col>
        </Row>
    );

    const RowThree = (

        <Row className="fixed-row-one">
            <Col lg={8} className={defaultInput}>

                <Col lg={2} className={[requiredInput, "proposal-label-large proposal-wide-input"]}>納品可能日</Col>

                <Col lg={10} className="proposal-day-check">
                    <table className="table table-no-hover">
                        <tbody>
                            <tr className="text-center">
                                {DAY_KANA_CUSTOM.map((item) => <td key={item}>{item}</td>)}
                            </tr>
                            <tr>
                                {props.dayFlags.map((item) => <td style={checkboxStyle} key={item}>{checkBox(item)}</td>)}
                            </tr>
                        </tbody>
                    </table>
                </Col>

            </Col>

            <Col lg={4} className="proposal-input" >

                <Row className="fixed-row small-row-field">
                    <Col lg={4} className={[requiredInput, formLabel, "proposal-right-label"]}>発注締切日</Col>
                    <Col lg={8} className={[formContent, "proposal-right-input"]}>
                        {selectForm("deadlineDay", props.dayValues)}
                    </Col>
                </Row>

                <Row className="fixed-row small-row-field">
                    <Col lg={4} className={[requiredInput, formLabel, "proposal-right-label"]}>発注締切時刻</Col>
                    <Col lg={8} className={[formContent, "proposal-time proposal-right-input"]}>
                        <Col lg={5} sm={2} xs={4} className={[defaultInput, "text-center"]}>
                            {selectForm("deadlineHour", hoursValue())}
                        </Col>
                        <Col lg={2} sm={1} xs={1} className={[formContent, "time-separator"]}>:</Col>
                        <Col lg={5} sm={2} xs={4} className={[defaultInput, "text-center"]}>
                            {selectForm("deadlineMinute", props.minuteValues)}
                        </Col>
                    </Col>
                </Row>

            </Col>
        </Row>
    );

    const RowFour = (
        <Row className="fixed-row remarks-row">
            <Col lg={12} className={defaultInput}>
                <Col lg={2} className={"proposal-label-medium"}>備考</Col>
                <Col lg={10} className={[formContent, "proposal-remarks"]}>
                    {textInput("remarks", "textarea", DEFAULT_MIN_LENGTH, MAX_REMARKS_LENGTH)}
                </Col>
            </Col>
        </Row>
    );

    const FormButtons = props.formButtons && props.formButtons.map((button, i) => {
        return (
            <Button key={i} disabled={button.disabled} className="button-common" onClick={button.onClick}>
                {button.label}
            </Button>
        );
    });

    return (
        <Form className="bg-white proposal-form-style">

            {RowOne}

            {RowTwo}

            {RowThree}

            {RowFour}

            <ButtonToolbar className="pull-right fixed-right proposal-buttons">
                {FormButtons}
            </ButtonToolbar>

        </Form>
    );
}

export default ProposalForm;
